/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/7
 */
export const USER_COOKIE_KEY = 'MEIZUSTORESESSIONVAL';



// WEBPACK FOOTER //
// ./src/config/index.js